
import { Options, Vue } from "vue-class-component";
import { UserController } from "@/app/ui/controllers/UserController";
import { AccountController } from "@/app/ui/controllers/AccountController";

import {
  checkRolePermission,
  parsingErrorResponse
} from "@/app/infrastructures/misc/Utils";
import { USER_MANAGEMENT } from "@/app/infrastructures/misc/RolePermission";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { ModalMessageEntities } from "@/domain/entities/MainApp";
import { AuthController } from "@/app/ui/controllers/AuthController";
import ModalEditDetail from "@/app/ui/views/user-management/component/modal-edit-detail.vue";
import isAssigned3lc from "@/app/infrastructures/misc/common-library/isAssigned3lc";
import formatDateUtil from "@/app/infrastructures/misc/common-library/v2/FormatDate";

@Options({
  components: {
    ModalEditDetail
  }
})
class DetailUser extends Vue {
  async created() {
    this.fetchUserData();
  }

  fetchUserData() {
    this.getDetailUserData(this.$route.params.id);
  }

  get isEditAble() {
    return (
      checkRolePermission(USER_MANAGEMENT.EDIT) &&
      AccountController.accountData.account_id.toString() !==
        this.$route.params.id
    );
  }

  get isAbleChangeRole() {
    return checkRolePermission(USER_MANAGEMENT.CHANGE_ROLE);
  }

  get isAbleChangeEmail() {
    return checkRolePermission(USER_MANAGEMENT.CHANGE_EMAIL);
  }

  get isAbleChangePassword() {
    return checkRolePermission(USER_MANAGEMENT.CHANGE_PASSWORD);
  }
  //Loading
  get isLoading() {
    return UserController.isLoadingDetail;
  }

  //Error
  get isError() {
    return UserController.isError;
  }

  //Error Cause
  get errorCause() {
    return UserController.errorCause;
  }

  getDetailUserData(id: any) {
    return UserController.getDetailUser({ id });
  }

  get dataDetail() {
    return UserController.userDetail;
  }

  get displayAssigned3lc() {
    return this.dataDetail.assigned3lc === "ALL"
      ? this.$t("userManagement.detail.all3lc")
      : this.dataDetail.assigned3lc?.split(",")?.join(", ");
  }

  formatDateDetail(date: string) {
    return formatDateUtil(date);
  }

  get isShowAssigned3Lc() {
    return isAssigned3lc({
      accountType: this.dataDetail.account_type,
      roleName: this.dataDetail.role_name
    });
  }

  get displayHub() {
    return this.dataDetail.partner?.type.match(/^console/);
  }

  get roleAccount() {
    return (
      AccountController.accountData.account_type_detail.type ||
      AccountController.accountData.account_type
    );
  }

  goBack() {
    this.$router.push(`/user-management`);
  }

  item = {
    status: "Inactive"
  };

  goEdit(id: string) {
    this.$router.push(`/user-management/edit/${id}`);
  }

  // reset password
  confirmationResetPassword() {
    MainAppController.setSnackbar(false);
    MainAppController.showMessageModal(
      new ModalMessageEntities({
        title: this.$t("userManagement.resetPassword.modalTitle"),
        message: this.$t("userManagement.resetPassword.modalMessage", {
          email: this.dataDetail.email
        }),
        textCancel: this.$t("userManagement.resetPassword.cancel"),
        textSuccess: this.$t("userManagement.resetPassword.submit"),
        onSubmit: () => this.submitResetPassword(),
        onClose: () => {
          MainAppController.closeMessageModal();
        },
        image: "are-you-sure"
      })
    );
  }
  async submitResetPassword() {
    MainAppController.closeErrorMessage();
    MainAppController.showLoading();
    MainAppController.closeMessageModal();
    const response = await AuthController.sendEmail({
      email: this.dataDetail.email
    });
    MainAppController.closeLoading();
    if (response.success) {
      MainAppController.setSnackbarMessage(
        this.$t("userManagement.resetPassword.successMessage", {
          email: this.dataDetail.email
        })
      );
      MainAppController.setSnackbar(true);
    } else {
      MainAppController.showErrorMessage(
        parsingErrorResponse(
          response.resp,
          this.$t("userManagement.resetPassword.errorTitle")
        )
      );
    }
  }

  modalEditDetail = false;
  typeEdit = "";
  async openModalEditDetail(type: string) {
    if (type === "role") {
      this.onGetRole(type);
    } else {
      MainAppController.setSnackbar(false);
      this.modalEditDetail = true;
      this.typeEdit = type;
    }
  }
  async onGetRole(type: string) {
    try {
      MainAppController.showLoading();
      UserController.setError(false);

      await UserController.getRole({
        // eslint-disable-next-line @typescript-eslint/camelcase
        account_type: this.dataDetail?.partner?.type || this.dataDetail.account_type
      });

      MainAppController.setSnackbar(false);
      this.typeEdit = type;
      this.modalEditDetail = true;
    } catch (error) {
      UserController.setError(true);
    } finally {
      MainAppController.closeLoading();
    }
  }

  get isInternalDataEntry(): boolean {
    return isAssigned3lc({ accountType: this.dataDetail.account_type, roleName: this.dataDetail.role_name })
  }
}
export default DetailUser;
